<div class="container-content">
     <div class="col" *ngIf="appService.theme$ | async as theme">
          <div class="dialog">No results found. Please try adjusting your 
               search items or broaden your search.
          </div>
          <button pRipple
               class="close-btn" 
               (click)="onClose()">
               Return to Search
          </button>
     </div>
</div>
